import React, { useEffect, useMemo, useState } from 'react'

import { TextField } from '../common/FormFields'
import { Autocomplete } from '../common/FormFields'
import { Select } from '../common/FormFields'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import FormControl from '@material-ui/core/FormControl'
import useDebounce from '../../hooks/useDebounce'
import styles from './tableFilters.module.scss'
import DatePicker from '../../components/common/FormFields/DatePicker'
const TableFilters = ({
  handleParamsChange,
  searchTitle,
  searchPlaceholder,
  buildingFilter,
  apartmentFilter,
  customFilters,
  rightChildren,
  building,
}) => {
  const [selectedBuilding, setSelectedBuilding] = useState(building)
  const [selectedApartment, setSelectedApartment] = useState(false)
  const [search, setSearch] = useState('')
  const customFiltersDefaultValues = useMemo(() => {
    if (!customFilters) return {}
    return customFilters.reduce((acc, filter) => {
      acc[filter.field] = filter.defaultValue
      return acc
    }, {})
  }, [customFilters])
  const [customFiltersState, setCustomFiltersState] = useState(
    customFiltersDefaultValues
  )

  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()
  const [
    { getApartmentsFromBuildingState, apartmentsState },
    { getApartmentsFromBuilding, getApartments },
  ] = useApartmentsApi()

  const onSearchChangeDebounced = useDebounce((value) => {
    setSearch(value)
    handleParamsChange({
      ...customFiltersState,
      search: value,
      apartmentId: selectedApartment?.id,
      buildingId: selectedBuilding?.id,
    })
  }, 600)

  useEffect(() => {
    const fetchData = async () => {
      getBuildings()
      getApartments()
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (building) {
      getApartmentsFromBuilding(building?.id)
      handleParamsChange({
        ...customFiltersState,
        search: search,
        apartmentId: selectedApartment?.id,
        buildingId: building?.id,
      })
    }
  }, [building])

  const renderCustomFilter = (filter) => {
    switch (filter.type) {
      case 'select':
        return (
          <div style={{ width: filter.width || '260px' }}>
            <Select
              field={{
                id: 'type',
                label: filter.label,
                hint: filter.label,
                key: filter.field,
                options: filter.options,
                withRightMargin: filter.withRightMargin,
                onChange: (evt) => {
                  setCustomFiltersState((state) => ({
                    ...state,
                    [filter.field]: evt.target.value,
                  }))
                  handleParamsChange({
                    search,
                    apartmentId: selectedApartment?.id,
                    buildingId: selectedBuilding?.id,
                    ...customFiltersState,
                    [filter.field]: evt.target.value,
                  })
                },
              }}
              values={customFiltersState}
            />
          </div>
        )
      case 'date':
        return (
          <DatePicker
            field={{
              errorMessage: 'La fecha de inicio es requerida',
              hint: 'Ingrese una fecha de inicio',
              key: filter.field,
              label: filter.label,
              type: 'DatePicker',
              withMargin: false,
            }}
            values={{ [filter.field]: customFiltersState[filter.field] }}
            errors={{ createdAt: null }}
            setValues={(data) => {
              setCustomFiltersState((state) => ({
                ...state,
                [filter.field]: data[filter.field],
              }))
              handleParamsChange({
                search,
                apartmentId: selectedApartment?.id,
                buildingId: selectedBuilding?.id,
                ...customFiltersState,
                [filter.field]: data[filter.field],
              })
            }}
          ></DatePicker>
        )
      default:
        return null
    }
  }

  return (
    <div className={styles.filterContainer}>
      {searchPlaceholder && (
        <FormControl
          variant="outlined"
          style={{ width: '400px', marginRight: '10px' }}
        >
          <TextField
            field={{
              label: searchTitle,
              key: 'search',
              hint: searchPlaceholder,
              capitalized: true,
            }}
            onChange={(evt) => {
              onSearchChangeDebounced(evt.target.value)
            }}
          />
        </FormControl>
      )}
      {buildingFilter && (
        <div style={{ width: '300px', marginRight: '10px' }}>
          <Autocomplete
            field={{
              label: 'Cliente',
              hint: 'Seleccione cliente',
              key: 'building',
              options: buildingsState.buildings,
              multiple: false,
              freeSolo: false,
              withMargin: false,
              onChange: (value) => {
                setSelectedBuilding(value)
                setSelectedApartment(null)
                handleParamsChange({
                  ...customFiltersState,
                  search: search,
                  apartmentId: null,
                  buildingId: value?.id,
                })
                getApartmentsFromBuilding(value?.id)
              },
              errorMessage: 'El cliente es requerido',
              value: selectedBuilding,
            }}
            values={{}}
          />
        </div>
      )}
      {apartmentFilter && (
        <div style={{ width: '300px', marginRight: '10px' }}>
          <Autocomplete
            field={{
              label: 'Unidad',
              hint: 'Seleccione unidad',
              key: 'apartment',
              options: getApartmentsFromBuildingState?.apartments?.sort(
                (a, b) => a.name.localeCompare(b.name)
              ),
              multiple: false,
              freeSolo: false,
              withMargin: false,
              onChange: (value) => {
                setSelectedApartment(value)
                handleParamsChange({
                  ...customFiltersState,
                  search: search,
                  apartmentId: value?.id,
                  buildingId: selectedBuilding?.id,
                })
              },
              errorMessage: 'El cliente es requerido',
              value: selectedApartment,
              disabled: !selectedBuilding,
            }}
            values={{}}
          />
        </div>
      )}
      {customFilters &&
        customFilters.map((filter) => renderCustomFilter(filter))}
      <div className={styles.rightChildren}>{rightChildren}</div>
    </div>
  )
}

export default TableFilters
